module.exports = __webpack_public_path__ + "static/img/png-2.89c9bc5f.png";